import ThemeToggle from './ThemeToggle/ThemeToggle.js';
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher.jsx';
import PropTypes from 'prop-types';

const AuthLayout = ({ children }) => {
    return (
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            top: '1rem',
            insetInlineEnd: '1rem',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            gap: '0.65rem',
          }}
        >
          <LanguageSwitcher />
          <ThemeToggle />
        </div>
        {children}
      </div>
    );
};

AuthLayout.propTypes = {
    children: PropTypes.node,
};

export default AuthLayout;
